import { useEffect, useRef, useState } from "react";
import { API, fmtWaktu, pesanGalat } from "../lib/api";
import { useAuth } from "../auth";
import Shell from "../components/Shell";
import {
  JudulHalaman, KerangkaBaris, KeadaanGalat, KeadaanKosong, StatusBaris,
  LencanaHistoris, useTabelKeys, KELAS_TABEL, KELAS_TH, KELAS_TD, KELAS_TR,
} from "../components/kit";

function FormBaru({ sistem, orang, onSelesai }) {
  const [f, setF] = useState({ orang_id: "", sistem_id: "", arah: "BUKA", hak: "", alasan: "", mode: "langsung", sumber_historis: "" });
  const [galat, setGalat] = useState(null);
  const kirim = async (e) => {
    e.preventDefault();
    setGalat(null);
    try {
      await API.post("/perubahan", { ...f, sumber_historis: f.mode === "historis" ? f.sumber_historis : null });
      onSelesai();
    } catch (err) { setGalat(pesanGalat(err)); }
  };
  return (
    <form onSubmit={kirim} className="panel rounded p-5 mb-6 grid md:grid-cols-3 gap-4" data-testid="form-baris-baru">
      <div>
        <label className="text-xs font-medium uppercase tracking-wide" htmlFor="f-orang">Orang</label>
        <select id="f-orang" data-testid="pilih-orang" required value={f.orang_id} onChange={(e) => setF({ ...f, orang_id: e.target.value })}
          className="mt-1 w-full border bg-background px-2 py-1.5 text-sm">
          <option value="">— pilih —</option>
          {orang.map((o) => <option key={o.id} value={o.id}>{`${o.kode} — ${o.nama_tampil}`}</option>)}
        </select>
      </div>
      <div>
        <label className="text-xs font-medium uppercase tracking-wide" htmlFor="f-sistem">Akses</label>
        <select id="f-sistem" data-testid="pilih-sistem" required value={f.sistem_id} onChange={(e) => setF({ ...f, sistem_id: e.target.value })}
          className="mt-1 w-full border bg-background px-2 py-1.5 text-sm">
          <option value="">— pilih —</option>
          {sistem.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
        </select>
      </div>
      <div>
        <label className="text-xs font-medium uppercase tracking-wide" htmlFor="f-arah">Arah</label>
        <select id="f-arah" data-testid="pilih-arah" value={f.arah} onChange={(e) => setF({ ...f, arah: e.target.value })}
          className="mt-1 w-full border bg-background px-2 py-1.5 text-sm">
          <option value="BUKA">BUKA</option>
          <option value="TUTUP">TUTUP</option>
        </select>
      </div>
      <div>
        <label className="text-xs font-medium uppercase tracking-wide" htmlFor="f-hak">Hak</label>
        <input id="f-hak" data-testid="input-hak" required value={f.hak} onChange={(e) => setF({ ...f, hak: e.target.value })}
          placeholder="cth. baca, tulis, admin" className="mt-1 w-full border bg-background px-2 py-1.5 text-sm" />
      </div>
      <div>
        <label className="text-xs font-medium uppercase tracking-wide" htmlFor="f-alasan">Alasan</label>
        <input id="f-alasan" data-testid="input-alasan" value={f.alasan} onChange={(e) => setF({ ...f, alasan: e.target.value })}
          className="mt-1 w-full border bg-background px-2 py-1.5 text-sm" />
      </div>
      <div>
        <label className="text-xs font-medium uppercase tracking-wide" htmlFor="f-mode">Mode</label>
        <select id="f-mode" data-testid="pilih-mode" value={f.mode} onChange={(e) => setF({ ...f, mode: e.target.value })}
          className="mt-1 w-full border bg-background px-2 py-1.5 text-sm">
          <option value="langsung">Langsung</option>
          <option value="historis">Historis (dicatat ulang)</option>
        </select>
      </div>
      {f.mode === "historis" && (
        <div className="md:col-span-3">
          <label className="text-xs font-medium uppercase tracking-wide" htmlFor="f-sumber">Sumber historis (wajib)</label>
          <input id="f-sumber" data-testid="input-sumber-historis" required value={f.sumber_historis}
            onChange={(e) => setF({ ...f, sumber_historis: e.target.value })}
            placeholder='cth. "chat WA 3 Feb 2026"' className="mt-1 w-full border bg-background px-2 py-1.5 text-sm" />
        </div>
      )}
      {galat && <p data-testid="galat-baris-baru" className="text-sm text-destructive md:col-span-3">{galat}</p>}
      <div className="md:col-span-3">
        <button data-testid="btn-catat-baris" className="tombol-utama px-4 py-2.5 rounded text-sm">
          Catat barisnya — nomor dan batas waktunya diisi server
        </button>
      </div>
    </form>
  );
}

export default function Perubahan() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  const [galat, setGalat] = useState(null);
  const [filter, setFilter] = useState({ arah: "", status: "", mode: "" });
  const [cari, setCari] = useState("");
  const [pilih, setPilih] = useState(null);
  const [catatan, setCatatan] = useState("");
  const [sistem, setSistem] = useState([]);
  const [orang, setOrang] = useState([]);
  const [teks, setTeks] = useState(null);
  const [tampilForm, setTampilForm] = useState(false);
  const [galatPanel, setGalatPanel] = useState(null);
  const [suratTerbit, setSuratTerbit] = useState(null);
  const salinRef = useRef(null);

  const muat = () => {
    setGalat(null);
    const q = Object.entries(filter).filter(([, v]) => v).map(([k, v]) => `${k}=${v}`).join("&");
    API.get(`/perubahan${q ? "?" + q : ""}`).then((r) => setRows(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(muat, [filter]);
  useEffect(() => {
    if (user?.peran === "admin") {
      API.get("/sistem").then((r) => setSistem(r.data)).catch(() => {});
      API.get("/orang").then((r) => setOrang(r.data)).catch(() => {});
      API.get("/perutean/teks").then((r) => setTeks(r.data)).catch(() => {});
    }
  }, [user]);

  const terfilter = (rows || []).filter((r) =>
    !cari || `${r.nomor} ${r.orang_nama} ${r.orang_kode} ${r.sistem_label} ${r.hak}`.toLowerCase().includes(cari.toLowerCase()));

  const ref = useTabelKeys((id) => setPilih(terfilter.find((r) => r.id === id)));
  const dipilih = pilih;

  const selesaikan = async () => {
    setGalatPanel(null); setSuratTerbit(null);
    try {
      const r = await API.post(`/perubahan/${dipilih.id}/selesai`, { catatan_bukti: catatan });
      setCatatan("");
      if (r.data.surat_terbit) setSuratTerbit(r.data.surat_terbit.nomor);
      else setPilih(null);
      muat();
    } catch (e) { setGalatPanel(pesanGalat(e)); }
  };
  const teruskan = async () => {
    setGalatPanel(null);
    try {
      await API.post(`/perubahan/${dipilih.id}/teruskan`);
      muat();
    } catch (e) { setGalatPanel(pesanGalat(e)); }
  };
  const salin = (t) => {
    navigator.clipboard?.writeText(t);
    if (salinRef.current) { salinRef.current.textContent = "Tersalin."; setTimeout(() => { if (salinRef.current) salinRef.current.textContent = ""; }, 1500); }
  };

  return (
    <Shell>
      <JudulHalaman testid="judul-permintaan" judul="Permintaan"
        sub="Satu baris, satu perubahan: dibuka atau ditutup. Tidak ada pilihan tengah." />

      {user?.peran === "admin" && (
        <div className="mb-4">
          <button data-testid="btn-tampil-form-baru" onClick={() => setTampilForm(!tampilForm)}
            className="tombol-utama px-4 py-2.5 rounded text-sm">
            {tampilForm ? "Tutup formulir" : "Catat perubahan baru"}
          </button>
        </div>
      )}
      {tampilForm && user?.peran === "admin" && (
        <FormBaru sistem={sistem} orang={orang} onSelesai={() => { setTampilForm(false); muat(); }} />
      )}

      {teks && (
        <details className="border p-3 mb-4">
          <summary className="text-sm font-medium cursor-pointer" data-testid="panel-teks-wa">Teks WhatsApp untuk disalin</summary>
          <div className="mt-3 space-y-2">
            {teks.map((t) => (
              <div key={t.kunci} className="flex items-start justify-between gap-4 border-b pb-2">
                <div>
                  <p className="text-xs text-muted-foreground">{t.judul}</p>
                  <p className="text-sm font-data">{t.teks}</p>
                </div>
                <button data-testid={`salin-${t.kunci}`} onClick={() => salin(t.teks)}
                  className="px-2 py-1 border text-xs shrink-0 transition-colors duration-150 hover:bg-secondary">Salin</button>
              </div>
            ))}
            <p ref={salinRef} className="text-xs text-emerald-600" aria-live="polite" />
          </div>
        </details>
      )}

      <div ref={ref} className="space-y-3" aria-label="Daftar perubahan akses">
        <div className="flex flex-wrap gap-2 items-center">
          <input data-cari data-testid="cari-permintaan" value={cari} onChange={(e) => setCari(e.target.value)}
            placeholder="Cari nomor, orang, akses, atau hak" aria-label="Cari perubahan akses"
            className="border bg-background px-3 py-1.5 text-sm w-64" />
          {[["arah", ["", "BUKA", "TUTUP"]], ["status", ["", "baru", "diteruskan", "selesai"]], ["mode", ["", "langsung", "historis"]]].map(([k, ops]) => (
            <select key={k} data-testid={`filter-${k}`} value={filter[k]} aria-label={`Filter ${k}`}
              onChange={(e) => setFilter({ ...filter, [k]: e.target.value })}
              className="border bg-background px-2 py-1.5 text-sm">
              {ops.map((o) => <option key={o} value={o}>{o || `semua ${k}`}</option>)}
            </select>
          ))}
        </div>

        {galat && <KeadaanGalat testid="galat-permintaan" pesan={galat} onCoba={muat} />}
        {!rows && !galat && <KerangkaBaris testid="memuat-permintaan" n={5} />}
        {rows && terfilter.length === 0 && (
          <KeadaanKosong testid="kosong-permintaan" teks="Belum ada catatan yang sesuai."
            aksiLabel={user?.peran === "admin" ? "Catat perubahan baru" : undefined} onAksi={() => setTampilForm(true)} />
        )}
        {rows && terfilter.length > 0 && (
          <div className="overflow-x-auto panel rounded">
            <table className={KELAS_TABEL} data-testid="tabel-permintaan">
              <thead>
                <tr>
                  <th className={KELAS_TH}>Nomor catatan</th><th className={KELAS_TH}>Status</th><th className={KELAS_TH}>Arah</th>
                  <th className={KELAS_TH}>Orang</th><th className={KELAS_TH}>Akses</th><th className={KELAS_TH}>Hak</th>
                  <th className={KELAS_TH}>Dicatat</th><th className={KELAS_TH}>Target selesai</th>
                  <th className={KELAS_TH}>{filter.arah === "TUTUP" ? "Jam paparan" : "Jam"}</th><th className={KELAS_TH}>Kanal</th>
                </tr>
              </thead>
              <tbody>
                {terfilter.map((r) => (
                  <tr key={r.id} data-row={r.id} tabIndex={-1} data-testid={`baris-${r.nomor}`}
                    onClick={() => setPilih(r)} className={`${KELAS_TR} ${r.mode === "historis" ? "baris-historis" : ""}`}>
                    <td className={`${KELAS_TD} font-data`}>{r.nomor}{r.mode === "historis" && <span className="block"><LencanaHistoris sumber={r.sumber_historis} /></span>}</td>
                    <td className={KELAS_TD}><StatusBaris status={r.status} terlewat={r.terlewat} /></td>
                    <td className={`${KELAS_TD} font-data font-medium`}>{r.arah}</td>
                    <td className={KELAS_TD}><span className="font-data">{r.orang_kode}</span> — {r.orang_nama}</td>
                    <td className={KELAS_TD}>{r.sistem_label}</td>
                    <td className={KELAS_TD}>{r.hak}</td>
                    <td className={`${KELAS_TD} font-data text-xs`}>{fmtWaktu(r.diminta_pada)}</td>
                    <td className={`${KELAS_TD} font-data text-xs`}>{r.status === "selesai" ? "—" : fmtWaktu(r.target_pada)}</td>
                    <td className={`${KELAS_TD} font-data`}>{r.jam != null ? `${r.jam} jam` : "—"}</td>
                    <td className={`${KELAS_TD} text-xs text-muted-foreground`}>{r.kanal}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {dipilih && (
        <aside data-testid="panel-detail" className="fixed inset-y-0 right-0 w-full max-w-md bg-card border-l p-6 overflow-y-auto z-30 shadow-2xl">
          <button data-testid="tutup-panel" onClick={() => setPilih(null)} className="text-sm underline mb-4">Tutup</button>
          <h2 className="font-heading text-xl font-semibold font-data">{dipilih.nomor}</h2>
          {galatPanel && <p data-testid="galat-selesai" className="mt-3 text-sm border border-destructive text-destructive p-2">{galatPanel}</p>}
          {suratTerbit && (
            <p data-testid="surat-terbit" className="mt-3 text-sm border-2 border-emerald-600 text-emerald-600 dark:text-emerald-400 p-2">
              Semua akses sudah ditutup. Surat Keterangan Bebas Akses terbit: <span className="font-data font-bold">{suratTerbit}</span>
            </p>
          )}
          <dl className="mt-4 space-y-2 text-sm">
            {[
              ["Arah", dipilih.arah], ["Orang", `${dipilih.orang_kode} — ${dipilih.orang_nama}`],
              ["Akses", dipilih.sistem_label], ["Hak", dipilih.hak],
              ["Dicatat oleh", dipilih.diminta_oleh], ["Waktu dicatat", fmtWaktu(dipilih.diminta_pada)],
              ["Target selesai", fmtWaktu(dipilih.target_pada)], ["Pemilik akses", dipilih.pemilik_nama || "belum ada"],
              ["Alasan", dipilih.alasan || "—"], ["Kanal", dipilih.kanal], ["Mode", dipilih.mode],
            ].map(([k, v]) => (
              <div key={k} className="flex justify-between gap-4 border-b pb-1">
                <dt className="text-muted-foreground">{k}</dt><dd className="text-right">{v}</dd>
              </div>
            ))}
            {dipilih.mode === "historis" && (
              <div className="pt-1"><LencanaHistoris sumber={dipilih.sumber_historis} /></div>
            )}
          </dl>
          {dipilih.status === "selesai" ? (
            <div className="mt-4 border p-3">
              <p className="text-xs uppercase tracking-wide text-muted-foreground">Catatan bukti</p>
              <p className="text-sm mt-1" data-testid="catatan-bukti-teks">{dipilih.catatan_bukti}</p>
              <p className="text-xs text-muted-foreground mt-2 font-data">selesai {fmtWaktu(dipilih.selesai_pada)} (waktu server)</p>
            </div>
          ) : (
            <div className="mt-6 space-y-3">
              {user?.peran === "admin" && dipilih.status === "baru" && (
                <button data-testid="btn-teruskan" onClick={teruskan}
                  className="w-full px-3 py-2 border text-sm transition-colors duration-150 hover:bg-secondary">
                  Kirim ke pemilik akses
                </button>
              )}
              <div>
                <label className="text-xs font-medium uppercase tracking-wide" htmlFor="catatan-bukti">Catatan bukti</label>
                <p className="text-xs text-accent mt-1">
                  Jangan tulis nama host, alamat IP, atau nama akun asli. Kalau terdeteksi, catatannya tidak akan tersimpan.
                </p>
                <textarea id="catatan-bukti" data-testid="input-catatan-bukti" rows={3} value={catatan}
                  onChange={(e) => setCatatan(e.target.value)} className="mt-1 w-full border bg-background px-2 py-1.5 text-sm" />
                <button data-testid="btn-selesai" onClick={selesaikan} disabled={!catatan.trim()}
                  className="mt-2 w-full px-3 py-2 bg-primary text-primary-foreground text-sm font-medium transition-colors duration-150 hover:opacity-90 disabled:opacity-50">
                  Tandai selesai
                </button>
              </div>
            </div>
          )}
        </aside>
      )}
    </Shell>
  );
}
